'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.SellerRemote = undefined;

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _helpers = require('./helpers');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SellerRemote = exports.SellerRemote = {
    fetchSellers: function fetchSellers(_ref) {
        var deployment = _ref.deployment;
        return new _promise2.default(function (resolve, reject) {
            var request = (0, _helpers.makeGet)('<ITEM-API>spa/small/sellers', deployment);
            request.end(function (err, response) {
                return (0, _helpers.handleResponse)(resolve, reject, err, response);
            });
        });
    },
    fetchSellersByIds: function fetchSellersByIds(_ref2) {
        var authToken = _ref2.authToken,
            deployment = _ref2.deployment,
            sellerIds = _ref2.sellerIds;
        return new _promise2.default(function (resolve, reject) {
            var request = (0, _helpers.makePost)('<ITEM-API>spa/small/sellers', deployment);
            (0, _helpers.addAuthToken)(request, authToken);
            request.send({ ids: sellerIds });
            request.end(function (err, response) {
                return (0, _helpers.handleResponse)(resolve, reject, err, response);
            });
        });
    },
    postFollow: function postFollow(_ref3) {
        var authToken = _ref3.authToken,
            deployment = _ref3.deployment,
            sellerId = _ref3.sellerId;
        return new _promise2.default(function (resolve, reject) {
            var request = (0, _helpers.makePost)('<ITEM-API>follow-seller/' + sellerId, deployment);
            (0, _helpers.addAuthToken)(request, authToken);
            request.type('form');
            request.send({ sellerId: sellerId });
            request.end(function (err, response) {
                return (0, _helpers.handleResponse)(resolve, reject, err, response);
            });
        });
    },
    postMessage: function postMessage(_ref4) {
        var authToken = _ref4.authToken,
            deployment = _ref4.deployment,
            messageDetails = _ref4.messageDetails;
        return new _promise2.default(function (resolve, reject) {
            var request = (0, _helpers.makePost)('<MAINHOST-API>api/s_msg', deployment);
            (0, _helpers.addAuthToken)(request, authToken);
            request.query({ client_version: '4.3' });
            request.type('form');

            if (messageDetails) {
                request.send({
                    cat_id: messageDetails.catalogId,
                    cc_sender: false,
                    house_id: messageDetails.sellerId,
                    lot_id: messageDetails.itemId,
                    message_text: messageDetails.message,
                    subject: messageDetails.subject
                });
            }
            request.end(function (err, response) {
                return (0, _helpers.handleResponse)(resolve, reject, err, response);
            });
        });
    },
    postUnfollow: function postUnfollow(_ref5) {
        var authToken = _ref5.authToken,
            deployment = _ref5.deployment,
            sellerId = _ref5.sellerId;
        return new _promise2.default(function (resolve, reject) {
            var request = (0, _helpers.makePost)('<ITEM-API>unfollow-seller/' + sellerId, deployment);
            (0, _helpers.addAuthToken)(request, authToken);
            request.type('form');
            request.send({ sellerId: sellerId });
            request.end(function (err, response) {
                return (0, _helpers.handleResponse)(resolve, reject, err, response);
            });
        });
    }
};


//////////////////
// WEBPACK FOOTER
// ./src/redux/api/remote/seller.js
// module id = e6NR
// module chunks = 46